export enum Font {
  Body = "PangeaText-Regular",
  BodyMedium = "PangeaText-Medium",
  Heading = "Pangea-Medium",
}
